import { Star } from "lucide-react";

export function StarRatingDisplay({ value = 0, size = 16 }) {
  return (
    <div className="flex gap-0.5" aria-label={`${value} von 5 Sternen`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-gold text-gold" : "text-champagne"}
        />
      ))}
    </div>
  );
}

export function StarRatingInput({ value, onChange, testId }) {
  return (
    <div className="flex gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`${testId}-${i}`}
          onClick={() => onChange(i)}
          className="transition-transform hover:scale-110"
          aria-label={`${i} Sterne`}
        >
          <Star size={26} className={i <= value ? "fill-gold text-gold" : "text-champagne"} />
        </button>
      ))}
    </div>
  );
}
